export const API_URL = process.env.REACT_APP_API_URL || 'https://dev.api.mintwms.com/api/v1';
export const MODE = process.env.NODE_ENV;
export const APP_NAME = process.env.REACT_APP_NAME || 'Mint WMS';
export const APP_SHORT_NAME = 'MWMS';
